
export default {

    text(){
        console.log(document.getElementById('excavationQualified'))
    }
}



// WEBPACK FOOTER //
// ./src/common/js/drawCharts.js